var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vl-layer-vector',{attrs:{"visible":_vm.layer.visible,"extent":_vm.imageExtent,"update-while-interacting":false}},[_c('vl-source-vector',{ref:"olSource",attrs:{"loader-factory":_vm.loaderFactory,"strategy-factory":_vm.strategyFactory,"url":"-"}},[_c('vl-style-func',{attrs:{"factory":_vm.styleFunctionFactory}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }